<template>
  <TrustTeaserCarousel class="carousel" :slides="slides">
    <template #headline>
      <h2 class="headline-h4-headline">{{ title }}</h2>
    </template>
  </TrustTeaserCarousel>
</template>

<script lang="ts" setup>
import type { TrustTeaserCardAppReviewProps } from '~/components/TrustTeaser/TrustTeaserCardAppReview.vue'
import type { TrustTeaserCardWinnerProps } from '~/components/TrustTeaser/TrustTeaserCardWinner.vue'

const { variant = 'winners' } = defineProps<{ variant?: 'winners' | 'reviews' }>()

const { data } = await useContent().getTrustTeaserCarousels()

const carousels = computed(() => data.value?.items?.[0] ?? null)

const winnerSlides = computed(() => {
  const items = carousels.value?.winnersSlidesCollection?.items ?? []

  // TODO Remove fallbacks when contentful schema finally gets it's shit together
  return items.filter(isTruthy).map<Omit<TrustTeaserCardWinnerProps, 'index'>>((item) => ({
    game: item.game ?? '',
    image: {
      alt: item.image?.description ?? '',
      src: item.image?.url ?? '',
    },
    state: item.state?.id ?? '',
    winningAmount: item.winningAmount ?? 0,
  }))
})

const reviewSlides = computed(() => {
  const items = carousels.value?.appReviewsSlidesCollection?.items ?? []

  // TODO Remove fallbacks when contentful schema finally gets it's shit together
  return items.filter(isTruthy).map<TrustTeaserCardAppReviewProps>((item) => ({
    date: item.date,
    rating: item.rating ?? 5,
    review: item.review ?? '',
    store: item.store ?? '',
    username: item.username ?? '',
  }))
})

const slides = computed(() => (variant === 'reviews' ? reviewSlides.value : winnerSlides.value))

const title = computed(() =>
  variant === 'reviews' ? carousels.value?.appReviewsTitle : carousels.value?.winnersTitle,
)
</script>

<style lang="scss" scoped>
.carousel {
  margin: 0.75rem -0.5rem 1rem;

  @include media-desktop {
    grid-column: 1 / -1;
    margin: -0.5rem -0.5rem 0.5rem;
  }
}
</style>
